import { render, staticRenderFns } from "./handle-cer-qualified.vue?vue&type=template&id=10f9aa9e"
import script from "./handle-cer-qualified.vue?vue&type=script&lang=js"
export * from "./handle-cer-qualified.vue?vue&type=script&lang=js"
import style0 from "./handle-cer-qualified.vue?vue&type=style&index=0&id=10f9aa9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports